/**
 * <RichTextSkeleton> — la forme d'un énoncé pendant qu'il arrive (molecule).
 *
 * Des lignes à la taille du texte de l'énoncé (`text-lg`), la dernière plus courte, comme la fin
 * d'un paragraphe. Posé par `<RichText>` pendant que son moteur se charge, et par les squelettes
 * qui attendent un énoncé (la fiche d'une activité, une carte en génération) : une retouche de la
 * taille du texte se voit partout sans recopie.
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"

export type RichTextSkeletonProps = {
    /** Combien de lignes, la dernière comprise. */
    lines: number
}

export function RichTextSkeleton({ lines }: RichTextSkeletonProps) {
    return (
        <Stack gap="1">
            {Array.from({ length: lines }, (_, index) => (
                <Skeleton key={index} textSize="text-lg" width={index === lines - 1 ? "60%" : undefined} />
            ))}
        </Stack>
    )
}
